var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHighlySensitive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53.49 59.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #805aed;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 1.5px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.79,18.3c0,3.98-2.05,7.49-5.16,9.52-3.11-2.03-5.16-5.53-5.16-9.52s2.05-7.49,5.16-9.52c3.11,2.03,5.16,5.53,5.16,9.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.79,18.3c0,3.98-2.05,7.49-5.16,9.52-3.11-2.03-5.16-5.53-5.16-9.52s2.05-7.49,5.16-9.52c3.11,2.03,5.16,5.53,5.16,9.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.64,27.82h0s0,.01,0,.01c2.13,2.25,5.31,3.42,8.58,2.82.07-.01.15-.03.22-.05,3.18-.63,5.68-2.81,6.86-5.6-1.01-1.06-2.24-1.89-3.61-2.4h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.65,27.82h0s0,.02,0,.02c-2.13,2.25-5.31,3.41-8.59,2.82-.07-.02-.14-.03-.22-.05-3.18-.63-5.67-2.81-6.85-5.6,1.01-1.06,2.24-1.88,3.61-2.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.63,27.82h.02c3.62.77,7.55-.27,10.36-3.08,2.82-2.83,3.84-6.75,3.08-10.38-2.9-.61-5.98-.08-8.55,1.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.65,27.8h0v.02h-.02c-3.63.77-7.55-.27-10.36-3.08-2.82-2.83-3.84-6.75-3.08-10.38,2.89-.61,5.98-.08,8.53,1.59"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.8,58.75H8.47v-18.12C3.73,36.43.75,30.38.75,23.66.75,11,11.27.75,24.24.75s23.47,10.25,23.47,22.91c0,.87-.05,1.74-.15,2.6-.05.43.03.86.24,1.23l4.71,8.26c.57.98,0,2.21-1.1,2.45l-4.84,1v7.84c0,1.35-1.1,2.45-2.47,2.45h-10.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.52,45.09l1.68,1.67c1.74,1.74,4.11,2.72,6.58,2.72"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 35.8,
    y1: 49.48,
    x2: 35.8,
    y2: 58.75
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlySensitive);
export default __webpack_public_path__ + "static/media/highly-sensitive.31f55e1f5b9835beddb092bba1a855fd.svg";
export { ForwardRef as ReactComponent };